import { Grid } from '@mui/material';
import React, { ComponentProps } from 'react';
import { PercentageBarRow } from './percentage-bar-row/percentage-bar-row.component';

export const PercentageBarChart = React.memo(function PercentageBarChart({
  rows
}: {
  rows: ComponentProps<typeof PercentageBarRow>[];
}) {
  return (
    <Grid container sx={{ flexDirection: 'column' }} spacing={1}>
      {rows.map((row) => (
        <Grid key={row.icon.alt}>
          <PercentageBarRow {...row} />
        </Grid>
      ))}
    </Grid>
  );
});
